import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '@app/core/services/auth/auth.service';
import { LogoService } from '@app/core/services/logo/logo.service';
import { UiButtonComponent } from '@app/shared/elements/ui-button/ui-button.component';

interface ErrorPageData {
  title: string;
  message: string;
  icon?: string;
}

const ERROR_CONFIG: Record<string, ErrorPageData> = {
  '503': {
    title: 'Service Unavailable',
    message:
      "We're currently experiencing a temporary service interruption. Our team is actively working to restore service as quickly as possible.",
    icon: 'uil-wrench'
  },
  '500': {
    title: 'Something Went Wrong',
    message: 'An unexpected error occurred. Please try again later.',
    icon: 'uil-exclamation-triangle'
  },
  '404': {
    title: 'Page Not Found',
    message: "The page you're looking for doesn't exist.",
    icon: 'uil-search'
  },
  default: {
    title: 'Application Error',
    message: 'Something went wrong. Please try again.',
    icon: 'uil-exclamation-triangle'
  }
};

@Component({
  selector: 'sliqpay-error-page',
   imports: [UiButtonComponent, RouterModule],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent {
  private readonly logoService = inject(LogoService);
  private readonly authService = inject(AuthService);

  readonly logoPath = this.logoService.getLogoFilePath('inverted');
  readonly isLoggedIn = this.authService.currentUser();

  data: ErrorPageData;

  constructor(private route: ActivatedRoute) {
    const code = this.route.snapshot.paramMap.get('code') || 'default';
    this.data = ERROR_CONFIG[code] || ERROR_CONFIG['default'];
  }
}
